import actionTypes from 'SRC/modules/redux/actionTypes'

export const setProductsLoading = (isLoading) => ({
  type: actionTypes.SET_PRODUCTS_LOADING,
  payload: isLoading
})
